// extracted by mini-css-extract-plugin
module.exports = {"image":"HelpWindow_image__2T8AV"};